import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoyaltyComponentsModule } from './components';
import { LoyaltyTypesModule } from './loyaltyTypes';

const toExport: any[] = [
    LoyaltyComponentsModule,
    LoyaltyTypesModule
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
    providers: [],
})
export class LoyaltyModule { }
